import { render, staticRenderFns } from "./VoucherPopup.vue?vue&type=template&id=a20b97ee"
import script from "./VoucherPopup.vue?vue&type=script&lang=js"
export * from "./VoucherPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports